/**
 * @file_purpose  compoment created for header of page
 * @author Khusir Alam
 * @Date_Created 28-02-2024
 * @Date_Modified 01-03-2024
 */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import MAINLOGO from '../../assets/images/mainlogo.png';
import GeneralService from '../../apis/GeneralService';
import ApiURL from '../../apis/ApiURL';
import AuthModal from '../auth/AuthModal';
import Constants from '../../utility/Constants';
import { listCurrency } from '../../redux/slices/changeCurrencySlice';
import LogoutModal from '../auth/LogoutModal';
import { activeLanguage, listLanguage } from '../../redux/slices/changeLanguageSlice';
import { activeAccount, listAccount } from '../../redux/slices/changeAccountSlice';
import { setAuthModal, setAuthType} from '../../redux/slices/authSlice';
import { storeUserDetails } from '../../redux/slices/UserDetailSlice';
import { Link } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';

const Header = () => {
    const dispatch = useDispatch();
    const [currencyList, setCurrenctList] = useState([])
    const [languageList, setLanguageList] = useState([]);
    const [accountList, setAccountList] = useState([]);
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    // const [authType, setAuthType] = useState("login");
    const [device, setDevice] = useState(() => localStorage.getItem('selectedDevice') || "");

    const userDetailState = useSelector((state) => state.userDetailState);
    let Balance = userDetailState?.user_details?.user_data?.available_balance || "";
    let Currency = userDetailState?.user_details?.user_data?.preffered_currency || "";
    let Name = userDetailState?.user_details?.user_data?.name || "";
    const languageState = useSelector((state) => state.languageState);
    const authType = useSelector((state)=>state.
    authState
    .auth_type)
    const authModal = useSelector((state)=>state.
    authState
    .auth_modal )
    const loginCreds = useSelector((state) => state.authState.logincreds);
    /**
 * @author Swarnali Ghosh
 * @Date_Created 28-02-2024
 * @Date_Modified 04/03/2023
 * @function async
 * @functionName loadCurrencyList
 * @functionPurpose this function gets currency list.
 * @functionParam {}
 * @functionSuccess Success status and message.
 * @functionError {Boolean} error is there.
 * @functionError {String} message  Description message.
 */

    async function loadCurrencyList() {

        GeneralService.apiGetCallRequestWithWToken(ApiURL.getCurrencyList).then(res => {
            if (res.error == Constants.API_RESPONSE_ERROR_FALSE) {

                setCurrenctList(res.data);
                dispatch(listCurrency(res.data))
            }
        }).catch(error => {

        })

    }

    /**
 * @author Swarnali Ghosh
 * @Date_Created 28-02-2024
 * @Date_Modified 04/03/2023
 * @function async
 * @functionName loadLanguageList
 * @functionPurpose this function gets language list.
 * @functionParam {}
 * @functionSuccess Success status and message.
 * @functionError {Boolean} error is there.
 * @functionError {String} message  Description message.
 */

    async function loadLanguageList() {

        GeneralService.apiGetCallRequestWithWToken(ApiURL.getLanguageList).then(res => {
            if (res.error == Constants.API_RESPONSE_ERROR_FALSE) {

                setLanguageList(res.data)
                dispatch(listLanguage(res.data))
            }
        }).catch(error => {

        })

    }


    /**
 * @author Sukhendu Mondal
 * @Date_Created 05-052025
 * @Date_Modified 04/03/2023
 * @function async
 * @functionName loadAccountList
 * @functionPurpose this function gets Provider Account list.
 * @functionParam {}
 * @functionSuccess Success status and message.
 * @functionError {Boolean} error is there.
 * @functionError {String} message  Description message.
 */

    async function loadAccountList() {

        GeneralService.apiGetCallRequestWithWToken(ApiURL.getAccountList).then(res => {
            if (res.error == Constants.API_RESPONSE_ERROR_FALSE) {
                
                setAccountList(res.data)
                dispatch(listAccount(res.data))
            }
        }).catch(error => {

        })

    }

    useEffect(() => {
        loadCurrencyList();
        loadLanguageList();
        loadAccountList();

    }, [])

    useEffect(() => {
        if (device) {
            localStorage.setItem('selectedDevice', device);
        } else {
            localStorage.removeItem('selectedDevice');
        }
    }, [device]);

    // Poll login API every 3 seconds to update balance
    useEffect(() => {
        if (!loginCreds) return;

        const pollLoginAPI = async () => {
            try {
                const params = JSON.stringify({
                    email: loginCreds.email,
                    password: loginCreds.password,
                    account_id: loginCreds.account_id
                });
                
                GeneralService.apiPostCallRequest(ApiURL.login, params, "").then(res => {
                    if (res.error == Constants.API_RESPONSE_ERROR_FALSE && res.message === "Login Success") {
                        dispatch(storeUserDetails(res.data));
                    }
                }).catch(error => {
                    console.log("Error polling login API:", error);
                });
            } catch (error) {
                console.log("Error in pollLoginAPI:", error);
            }
        };

        // Call immediately on mount
        pollLoginAPI();

        // Set up interval for polling every 3 seconds
        const intervalId = setInterval(pollLoginAPI, 3000);

        return () => clearInterval(intervalId);
    }, [loginCreds, dispatch])

    const openAuthModal = () => {
        dispatch(setAuthModal(!authModal))
        dispatch(setAuthType("login"))
    }

    const languageHandleChange = (language_code, language_name) => {

        let languageObject = { language_code: language_code, language_name: language_name };

        dispatch(activeLanguage(languageObject))
    }


    const handleModeChangeAuthModal = () => {

        if(authModal){
            dispatch(setAuthModal(false))
        }else{
            dispatch(setAuthModal(true))
        }
       
    }

    const handleChangeLogoutModal = () => {
        setShowLogoutModal(!showLogoutModal)
    }

    const handleChangeAuthType = () => {
        if (authType == "login") {
            dispatch(setAuthType("register"))
        } else {
            dispatch(setAuthType("login"))
        }
    }

    const openLogoutModal = () => {
        setShowLogoutModal(!showLogoutModal)
    }

    
    return (


        <div className="head_main">
            <div className="container">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="head_sec">
                            <div className="logo_sec">
                                <Link to="/"><img src={MAINLOGO} alt="logo" style={{ width: "180px", height: "auto" }}/></Link>
                            </div>
                            
                            {/* {
                                userDetailState?.user_details ? 
                                <div className='' style={{ color: "white" }}>
                                    Balance: {`${Balance.toFixed(2)} ${Currency}`}
                                </div> 
                                : ""
                            } */}

                            {
                                userDetailState?.user_details ? 
                                <div className="header-balance">
                                    Balance: {`${Balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${Currency}`}
                                </div> 
                                : ""
                            }

                            <div className="header-actions">
                                <div className="device_sec">
                                    <div className="dropdown device-dropdown">
                                        <button
                                            className="btn btn-secondary device-select-btn dropdown-toggle"
                                            type="button"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            {device ? (device === 'desktop' ? 'Desktop' : 'Mobile') : 'Device Select'}
                                        </button>
                                        <ul className="dropdown-menu">
                                            <li>
                                                <button className="dropdown-item" type="button" onClick={() => setDevice('')}>Device Select</button>
                                            </li>
                                            <li>
                                                <button className="dropdown-item" type="button" onClick={() => setDevice('desktop')}>Desktop</button>
                                            </li>
                                            <li>
                                                <button className="dropdown-item" type="button" onClick={() => setDevice('mobile')}>Mobile</button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>


                                <div className="head_rt">

                                    <div className="language_sec">
                                        {Name ? <div className="lang">{Name}</div> : ""}
                                        <div className="sign_in logout">
                                    <Dropdown hidden ={userDetailState?.user_details ? false : true}>
                                                <Dropdown.Toggle variant="secondary" id="logout-dropdown">
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu align="end">
                                            <Dropdown.Item >
                                                        <button type="button" className='log_sec' onClick={userDetailState.user_details && openLogoutModal}>Logout</button>
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                            <button hidden={userDetailState?.user_details && true}
                                                type="button" value="Signin" onClick={openAuthModal}>Sign In</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <AuthModal authType={authType} handleChangeAuthType={handleChangeAuthType} showAuthModal={authModal} handleModeChangeAuthModal={handleModeChangeAuthModal} />
            <LogoutModal showLogoutModal={showLogoutModal} handleChangeLogoutModal={handleChangeLogoutModal} />
        </div>
    )
}

export default Header
